Pluswerk.PlusProject.Utility.AccessibilityController = Pluswerk.PlusProject.Utility.AccessibilityController || {};
/**
 * AccessibilityController
 *
 */
Pluswerk.PlusProject.Utility.AccessibilityController = {
  init: function () {
    var instance = Pluswerk.PlusProject.Utility.AccessibilityController;
    var elements = document.querySelectorAll('.js-accessibilityAddTitle');
    $.each(elements, function () {
      this.addEventListener('click', function () {
        var $this = $(this);
        instance.addTitle($this);
      });
    });
  },
  addAria: function ($elem, aria) {
    $elem.attr(aria, function (index, attr) {
      return attr === 'true' ? false : true;
    });
  },
  addTitle: function ($elem) {
    var showTitle = $elem.attr('data-titleShow');
    var hideTitle = $elem.attr('data-titleHide');
    $elem.attr('title', function (index, attr) {
      return attr === showTitle ? hideTitle : showTitle;
    });
  },
  addTitleType: function ($elem, type) {
    if (type === 'hideTitle') {
      $elem.attr('title', $elem.attr('data-titleHide'));
    } else {
      $elem.attr('title', $elem.attr('data-titleShow'));
    }
  }
};

